$(document).ready(function () {


  var $owl = $(".hero_slider").owlCarousel({
    items: 1,
    dots: false,
    nav: false,
    loop: true,
    autoplay: true,
    smartSpeed: 750,
    onInitialized: addAccessibility,
    onTranslated: updateSlideFocus,
    onChanged: updateDotsAccessibility
  });

  function addAccessibility(event) {
    var carousel = event.target;
    $(carousel).find('.owl-prev').attr('aria-label', 'Previous slide');
    $(carousel).find('.owl-next').attr('aria-label', 'Next slide');
    
    $(carousel).find('.owl-item').attr('role', 'group');
    $(carousel).find('.owl-item').each(function(index) {
      $(this).attr('aria-label', 'Slide ' + (index + 1));
    });

    updateDotsAccessibility(event);
  }

  function updateSlideFocus(event) {
    var carousel = event.target;
    var currentItem = $(carousel).find('.owl-item').eq(event.item.index);
    currentItem.find('[tabindex]').focus();
  }

  function updateDotsAccessibility(event) {
    var carousel = event.target;
    var dots = $(carousel).find('.owl-dot');
    dots.each(function(index) {
      $(this).attr('aria-label', 'Slide dot ' + (index + 1));
      $(this).attr('role', 'button');
    });
  }

  $owl.find("img").each(function () {
    $(this).css("opacity", 1);
    $(this).css("visibility", "inherit");
  });
});
